export default "__VITE_ASSET__DNxkJtDB__"